import React from "react"
import EditableTableHolder from "../components/EditableDiscountTableHolder"
import { Button } from "semantic-ui-react"
import { authorize, authorizeAction } from "../decorators/authorize"
import requireStore from "../decorators/requireStore"
import { discountPage } from "../config/routesInfo"
import { canReport } from "../config/permissions"
import { connect } from "react-redux"
import {
  getData,
  editDiscounts,
  createDiscount,
  deleteDiscount,
  deleteItems,
} from "../ducks/discounts"
import { withTranslation } from "react-i18next"

const columns = [
  {
    title: "title",
    name: "title",
    dataType: "string",
    // sortable: true,
    // editable: true,
  },
  {
    title: "from",
    name: "startedAt",
    dataType: "date",
    // sortable: true,
    // editable: true,
  },
  {
    title: "to",
    name: "finishAt",
    dataType: "date",
    // sortable: true,
    // editable: true,
  },
  {
    title: "discountPercent",
    name: "percent",
    dataType: "number",
    // sortable: true,
    // editable: true,
  },
  {
    title: "amountProduct",
    name: "amount",
    dataType: "number",
    render: (item) => <div>{item.length}</div>,
  },
]

const innerColumns = [
  {
    title: "titleProduct",
    name: "name",
    dataType: "string",
    sortable: true,
    editable: true,
  },
  {
    title: "priceSale2",
    name: "salePrice",
    dataType: "string",
    sortable: true,
    editable: true,
  },
]

@authorize(...discountPage.permissions)
// @requireStore()
@withTranslation()
@connect(
  (state) => ({
    currentStoreId: state.profile.currentStore.id,
    data: state.discounts.data,
    totalCount: state.discounts.totalCount,
    storeOptions: state.profile.stores.map((s) => ({
      value: s.id,
      text: s.name,
      name: s.name,
      key: s.id,
      address: s.address,
    })),
  }),
  (dispatch) => ({
    refresh: () => dispatch(getData()),
    onEdit: (...data) => dispatch(editDiscounts(...data)),
    onCreate: (data) => dispatch(createDiscount(data)),
    onDelete: (data) => dispatch(deleteDiscount(data)),
    onItemDelete: (data, id) => dispatch(deleteItems(data, id)),
  }),
)
export default class DiscountPage extends React.Component {
  // eslint-disable-next-line react/no-deprecated
  componentWillReceiveProps(newProps) {
    const { currentStoreId, refresh } = this.props
    if (newProps.currentStoreId !== currentStoreId) {
      refresh()
    }
  }

  componentDidMount() {
    this.props.refresh()
    // const { onSort } = this.props
    // onSort("at")
  }

  render() {
    const { t } = this.props
    const {
      onSort,
      data,
      onEdit,
      onDelete,
      onItemDelete,
      storeOptions,
      onCreate,
      totalCount,
    } = this.props
    const tableData = {
      columns,
      // activeFilters,
      // sortedBy,
      // sortedAsc,
      data,
      // isLoading,
      // // onDelete,
      onEdit,
      onDelete,
      // changeFilters,
    }
    const innerTable = {
      propName: "items",
      title: t("discountToProduct"),
      tableData: {
        columns: innerColumns,
        data: [],
        // onEdit: onEdit,
        onDelete: onItemDelete,
      },
    }

    return (
      <div>
        <EditableTableHolder
          title={t("discount")}
          info={t(
            "In this section you can create, modify and delete stocks of your stores",
          )}
          // currentPage={currentPage}
          // pagesCount={pagesCount}
          searchInfo={t("searchWithBarcodeName")}
          exportInfo="Экспорт"
          // onExport={authorizeAction(canReport).onFail((callback) => callback())(
          //   onExport,
          // )}
          // onPageSelect={onPageSelect}
          // onSearch={onSearch}
          tableData={tableData}
          // isLoading={isLoading}
          innerTable={innerTable}
          totalCount={totalCount}
          button={true}
          storeOptions={storeOptions}
          onCreate={onCreate}
        />
      </div>
    )
  }
}
